import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import '../css/pages_styles.css';

const Wasn_committee = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    // 委員名單數據
    const committeeMembers = {
        column1: [
            '王友群教授 國立中山大學',
            '王能中教授 國立聯合大學',
            '王鴻猷教授 國立高雄科技大學',
            '朱宗賢教授 國立雲林科技大學',
            '吳世琳教授 長庚大學',
            '林勻蔚教授 國立陽明交通大學',
            '林致宇教授 國立臺灣海洋大學',
            '林朝興教授 國立臺南大學',
            '周肇基教授 國立高雄科技大學',
            '柯崴傑博士 考試院銓敘部',
            '施淵耀教授 國立中正大學',
            '莊清智教授 國立屏東大學',
            '翁永昌教授 靜宜大學',
            '陳仁暉教授 長庚大學',
            '陳伶志教授 中央研究院',
            '陳建志教授 國立陽明交通大學',
            '陳俊良教授 國立臺灣科技大學',
            '陳裕賢教授 國立臺北大學',
            '陳懷恩教授 亞洲大學',
            '許智舜教授 世新大學',
            '梁世聰教授 國立臺北市立大學',
            '張志勇教授 淡江大學',
            '張英超教授 國立彰化師範大學',
            '張瑞雄教授 國立臺北商業大學',
            '黃俊龍教授 國立陽明交通大學',
            '黃啟富教授 國立中正大學',
            '蒯思齊教授 國立臺北商業大學',
            '楊明豪教授 中原大學',
            '楊舜仁教授 國立清華大學',
            '趙志民教授 國立臺灣海洋大學',
            '蔡子傑教授 國立政治大學',
            '蔡崇煒教授 國立中山大學',
            '鄭建富教授 國立臺灣海洋大學',
            '劉傳銘教授 國立臺北科技大學',
            '賴傳淇教授 國立中正大學',
            '簡廷軒教授 國立中正大學',
            '蘇淑茵教授 國立成功大學',
            '嚴力行教授 國立陽明交通大學'
        ],
        column2: [
            '王丕中教授 國立中興大學',
            '王蒞君教授 國立陽明交通大學',
            '石貴平教授 淡江大學',
            '呂政修教授 國立臺灣科技大學',
            '邱德泉教授 國立清華大學',
            '林　風教授 國立臺灣大學',
            '林家瑜教授 國立中央大學',
            '周立德教授 國立中央大學',
            '俞征武教授 中華大學',
            '莊東穎教授 國立臺北大學',
            '連紹宇教授 國立陽明交通大學',
            '高榮駿教授 國立清華大學',
            '陳永隆教授 國立臺中科技大學',
            '陳宗禧教授 國立臺南大學',
            '陳昱嘉教授 國立中央大學',
            '陳烈武教授 逢甲大學',
            '陳維美教授 國立臺灣科技大學',
            '婁德權教授 長庚大學',
            '許慶賢教授 亞洲大學',
            '梁家銘教授 國立臺南大學',
            '張宏義教授 國立嘉義大學',
            '張林煌教授 國立臺中教育大學',
            '黃永發教授 朝陽科技大學',
            '黃崇源教授 長庚大學',
            '曾建超教授 國立陽明交通大學',
            '楊竹星教授 國立成功大學',
            '楊朝棟教授 東海大學',
            '溫演福教授 國立臺北大學',
            '趙禧綠教授 國立陽明交通大學',
            '蔡明峰教授 國立聯合大學',
            '廖文華教授 國立臺北商業大學',
            '劉炳宏教授 國立高雄科技大學',
            '潘仁義教授 國立中正大學',
            '謝奇文教授 國立中正大學',
            '簡暐哲教授 國立東華大學',
            '蘇暉凱教授 國立虎尾科技大學',
            '王志宇教授 中央研究院資訊科技創新研究中心',
            '陳耘志教授 國立清華大學'
        ]
    };

    // 在手機版合併所有成員為一個列表
    const allMembers = isMobile ? 
        [...committeeMembers.column1, ...committeeMembers.column2].sort() : 
        { column1: committeeMembers.column1, column2: committeeMembers.column2 };

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                        className="header"
                    >
                        <h1 className="title">WASN 委員會成員</h1>
                    </header>
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className={`column-list ${isMobile ? 'column-list-mobile' : ''}`}>
                            {isMobile ? (
                                // 手機版：單欄顯示
                                <ul className="list">
                                    {allMembers.map((member, index) => (
                                        <li key={index} className="list-item list-item-mobile">
                                            {member}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                // 桌面版：雙欄顯示
                                <>
                                    <ul className="list">
                                        {committeeMembers.column1.map((member, index) => (
                                            <li key={index} className="list-item">
                                                {member}
                                            </li>
                                        ))}
                                    </ul>
                                    <ul className="list">
                                        {committeeMembers.column2.map((member, index) => (
                                            <li key={index} className="list-item">
                                                {member}
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            )}
                        </div>
                    </section>
                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default Wasn_committee;